import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-start gap-2" }
const _hoisted_2 = { class: "text-white font-sourcesanspro-regular" }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

interface Language {
	value: string;
	label: string;
	flagClass: string;
	default?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LanguageSelect',
  props: {
    modelValue: {},
    availableLanguages: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const props = __props;

const emit = __emit;

const modelValue = computed({
	get: () => props.modelValue,
	set: (val: string) => emit('update:modelValue', val),
});

const selectedLanguage = computed(() => props.availableLanguages.find((lang) => lang.value === modelValue.value));

return (_ctx: any,_cache: any) => {
  const _component_ion_radio = _resolveComponent("ion-radio")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ion_list, { class: "ion-no-padding w-full bg-transparent" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLanguages, (language) => {
          return (_openBlock(), _createBlock(_component_ion_item, {
            key: language.value,
            class: _normalizeClass(["text-white font-sourcesanspro-regular cursor-pointer", { 'selected': modelValue.value === language.value }]),
            lines: "none",
            onClick: ($event: any) => (modelValue.value = language.value)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_radio, {
                value: language.value,
                checked: modelValue.value === language.value,
                class: "mr-4"
              }, null, 8, ["value", "checked"]),
              _createVNode(_component_ion_label, { class: "flex items-center" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: _normalizeClass([language.flagClass, "mr-2"]),
                    style: {"width":"1.5em","height":"1em"}
                  }, null, 2),
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)(language.label)), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["class", "onClick"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})